import {
  CURRICULUM_TIME_UNITS,
  type CurriculumTimeUnit
} from '@/modules/curriculumsManagement'
import type { IdAndName } from '@/types/id-and-name'
import {
  getRandomBoolean,
  getRandomFromArray,
  getRandomInt
} from '@/utils/mocks'

type Semester = {
  hours: number | null
  is_active: boolean
}

type CurriculumBasketCourse = {
  id?: string
  course: IdAndName
  time_unit: CurriculumTimeUnit
  semesters: Semester[]
}

const createSemesterMock = (): Semester => {
  const hours = getRandomBoolean() ? getRandomInt(0, 25) : null

  return { hours, is_active: hours !== null }
}

export const createCurriculumBasketCourseMock = (
  curriculumId: string,
  courseId: string
): CurriculumBasketCourse => ({
  id: `${curriculumId}-${courseId}`,
  course: {
    id: courseId,
    name: 'Course'
  },
  time_unit: getRandomFromArray(CURRICULUM_TIME_UNITS),
  semesters: Array.from({ length: getRandomInt(1, 13) }, createSemesterMock)
})
